import { useFormikContext } from 'formik';
import { cloneDeep, get, set } from 'lodash';
import React from 'react';
import { Button } from 'react-bootstrap';

import { NumberField } from 'Shared/form/NumberField';
import SelectField from 'Shared/form/SelectField';
import { TextField } from 'Shared/form/TextField';
import { fieldOptionsList } from '../constants';

const QueueManagerTable = () => {
    const { values, setFieldValue, setValues, validateForm } = useFormikContext();
    const fieldOrderIndex = values.fieldOrders.findIndex(
        (fieldOrder) => fieldOrder.branch.division_id === values.selectedBranch.division_id
    );
    const fieldPrefix = `fieldOrders[${fieldOrderIndex}].field_order`;
    const branchFieldOrders = get(values, fieldPrefix);

    return (
        <table className="therigy-table">
            <thead>
                <tr>
                    <th id="edit-header-name-column">Edit Header Name</th>
                    <th id="information-to-display-column">Information to Display</th>
                    <th id="column-order-column">Column Order</th>
                    <th>Remove</th>
                </tr>
            </thead>
            <tbody>
                {branchFieldOrders.map((branchFieldOrder, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <tr key={index}>
                        <td>
                            <TextField
                                fieldName={`${fieldPrefix}[${index}].name_of_header`}
                                placeholder="Header Name"
                                aria-labelledby="edit-header-name-column"
                                required
                            />
                        </td>
                        <td>
                            <SelectField
                                fieldName={`${fieldPrefix}[${index}].field_selected`}
                                options={fieldOptionsList}
                                isDisabled={branchFieldOrder.required}
                                isOptionDisabled={(option) =>
                                    branchFieldOrders.find(
                                        (fieldOrder) => fieldOrder.field_selected?.value === option.value
                                    )
                                }
                                onChange={(value) => {
                                    const newValues = cloneDeep(values);
                                    set(newValues, `${fieldPrefix}[${index}].field_selected`, value);
                                    set(newValues, `${fieldPrefix}[${index}].name_of_header`, value.label);
                                    setValues(newValues);
                                }}
                                aria-labelledby="information-to-display-column"
                                required
                            />
                        </td>
                        <td>
                            <NumberField
                                fieldName={`${fieldPrefix}[${index}].field_order`}
                                aria-labelledby="column-order-column"
                                min={1}
                                onlyIntegers
                            />
                        </td>
                        <td>
                            {!branchFieldOrder.required && (
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => {
                                        const newBranchFieldOrders = [...branchFieldOrders];
                                        newBranchFieldOrders.splice(index, 1);
                                        setFieldValue(fieldPrefix, newBranchFieldOrders);
                                        setImmediate(() => validateForm());
                                    }}
                                >
                                    Remove
                                </Button>
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default QueueManagerTable;
